import type { Padding } from '@ui/types/base/padding'

const paddingMap: Record<Padding, string> = {
  sm: 'py-1 px-2',
  md: 'py-2 px-3',
  lg: 'py-3 px-4',
  xl: 'py-3 px-4',
  ['2xl']: 'py-3 px-4',
  ['3xl']: 'py-3 px-4',
  ['4xl']: 'py-3 px-4',
  none: 'p-0'
}

export const usePadding = (padding: Padding) => paddingMap[padding]
